import useAccountInformation from '@/auth/hooks/useAccountInformation'
import type {AccountInformation} from '@/auth/model'
import {getFoodCart} from '@/lib/food/foodPaymentService'
import type {SupportedLocales} from '@/lib/locale/locale'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export function getFoodCartQueryKey(
  locale: SupportedLocales,
  account: AccountInformation | undefined,
) {
  return ['foodCart', locale, account?.id] as const
}

export function getFoodCartQueryOptions(
  locale: SupportedLocales,
  account: AccountInformation | undefined,
) {
  return queryOptions({
    queryKey: getFoodCartQueryKey(locale, account),
    queryFn: async ({signal}) => getFoodCart({locale, isAuthenticated: !!account, signal}),
    throwOnError: false,
    ...NO_REFETCH_OPTIONS,
  })
}

export function useFoodCart(locale: SupportedLocales) {
  const [account] = useAccountInformation()
  return useQuery(getFoodCartQueryOptions(locale, account))
}
